import Text from "@sproutsocial/seeds-react-text";
import type {
  TypeFieldsetLegendProps,
  TypeFieldsetHelperText,
} from "./FieldsetTypes";

/**
 * Text-based legend and helper-text parts for Fieldset.
 *
 * These remain styled-components (Text) because they are exposed as the public
 * Fieldset.Legend / Fieldset.HelperText statics and accept arbitrary
 * styled-system props. They are shared by both the styled-components branch of
 * FieldsetHybrid and the compound statics attached in Fieldset.tsx.
 */
export const FieldsetLegend = ({
  children,
  ...rest
}: TypeFieldsetLegendProps) => (
  <Text
    as="legend"
    fontSize={300}
    fontWeight="semibold"
    color="text.body"
    mb={300}
    {...rest}
  >
    {children}
  </Text>
);

export const FieldsetHelperText = ({
  children,
  ...rest
}: TypeFieldsetHelperText) => (
  <Text as="p" fontSize={200} mb={300} {...rest}>
    {children}
  </Text>
);

FieldsetLegend.displayName = "Fieldset.Legend";
FieldsetHelperText.displayName = "Fieldset.HelperText";
